import { render, staticRenderFns } from "./MoveVisitModal.vue?vue&type=template&id=087d77aa"
import script from "./MoveVisitModal.vue?vue&type=script&lang=js"
export * from "./MoveVisitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports